import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { UserRound, Star, Handshake } from 'lucide-react';
const Testimonials = () => {
  return <section id="testimonials" className="section-padding bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-maroon mb-4">
            Team Integration & Client Success Stories
          </h2>
          <p className="text-charcoal-light text-lg max-w-2xl mx-auto">
            Kristen seamlessly integrates with your existing team to drive success. 
            Hear how she's built strong collaborative relationships across organizations.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <Card className="bg-cream shadow-sm">
            <CardContent className="p-8">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#722F37" color="#722F37" className="mr-1" />)}
              </div>
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <Avatar className="h-12 w-12 bg-maroon/20">
                    <AvatarFallback className="text-maroon">LD</AvatarFallback>
                  </Avatar>
                </div>
                <div>
                  <p className="font-semibold text-charcoal">Lindsey DellaVecchia</p>
                  <p className="text-charcoal-light text-sm">CEO</p>
                </div>
              </div>
              <p className="text-charcoal mb-6 italic">
                "I highly recommend Kristen to any business. I look back and wonder how we did
                prior to her, she has helped propel the team and client experience, but most
                importantly <span className="font-medium">gave the management team time back to really grow</span>. Kristen <span className="font-medium">integrated seamlessly with our existing staff</span> and created systems that improved both team morale and client satisfaction."
              </p>
              <div className="flex items-center gap-2 text-sm text-maroon">
                <Handshake size={16} />
                <span>Collaborated on cross-departmental operational improvements</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-cream shadow-sm">
            <CardContent className="p-8">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#722F37" color="#722F37" className="mr-1" />)}
              </div>
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <Avatar className="h-12 w-12 bg-maroon/20">
                    <AvatarFallback className="text-maroon">TB</AvatarFallback>
                  </Avatar>
                </div>
                <div>
                  <p className="font-semibold text-charcoal">Todd Bailey</p>
                  <p className="text-charcoal-light text-sm">Former Associate</p>
                </div>
              </div>
              <p className="text-charcoal mb-6 italic">
                "Leading a company takes confidence, logic, and empathy. Kristen <span className="font-medium">fosters a positive company culture through mentoring and empowering employees</span>. She's organized, respectful, and decisive — a <span className="font-medium">strong business leader who can organize staff and operations</span> across diverse teams and departments."
              </p>
              <div className="flex items-center gap-2 text-sm text-maroon">
                <UserRound size={16} />
                <span>Coordinated effectively with leadership and staff</span>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <Card className="bg-cream shadow-sm">
            <CardContent className="p-8">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#722F37" color="#722F37" className="mr-1" />)}
              </div>
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <Avatar className="h-12 w-12 bg-maroon/20">
                    <AvatarFallback className="text-maroon">CP</AvatarFallback>
                  </Avatar>
                </div>
                <div>
                  <p className="font-semibold text-charcoal">Colleen Pace</p>
                  <p className="text-charcoal-light text-sm">Sr. HR Generalist, MicroCare LLC</p>
                </div>
              </div>
              <p className="text-charcoal mb-6 italic">
                "I worked with Kristen for 11 years and would recommend her in any management role. She's a <span className="font-medium">strong leader with excellent communication skills, team building ability</span>, and project management expertise. She <span className="font-medium">works collaboratively across departments</span> and is a great addition to any company looking for strong leadership."
              </p>
              <div className="flex items-center gap-2 text-sm text-maroon">
                <Handshake size={16} />
                <span>11+ years of successful cross-team collaboration</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-cream shadow-sm">
            <CardContent className="p-8">
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#722F37" color="#722F37" className="mr-1" />)}
              </div>
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <Avatar className="h-12 w-12 bg-maroon/20">
                    <AvatarFallback className="text-maroon">AD</AvatarFallback>
                  </Avatar>
                </div>
                <div>
                  <p className="font-semibold text-charcoal">Al D'Amico</p>
                  <p className="text-charcoal-light text-sm">Business Partner</p>
                </div>
              </div>
              <p className="text-charcoal mb-6 italic">
                "Kristen is an exceptional operations leader who <span className="font-medium">brings teams together</span> to achieve common goals. Her ability to <span className="font-medium">navigate complex organizational structures</span> while maintaining positive relationships at all levels is impressive. She <span className="font-medium">values input from all team members</span> and creates an environment where everyone feels heard and valued."
              </p>
              <div className="flex items-center gap-2 text-sm text-maroon">
                <UserRound size={16} />
                <span>Built strong cross-functional partnerships</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default Testimonials;